import React from "react";
import { Box } from "@mui/material";
import { DocumentHead } from "../components/common/DocumentHead";
import { JsonLd } from "../components/common/JsonLd";
import { ROUTES } from "../config";
import Hero from "../components/sections/Hero";
import Features from "../components/sections/Features";
import HowItWorks from "../components/sections/HowItWorks";
import TemplateShowcase from "../components/sections/TemplateShowcase";
import VSCodeExtension from "../components/sections/VSCodeExtension";
import CTA from "../components/sections/CTA";

const HOME_TITLE = "Rusha - Cloud Deployments Made Simple";
const HOME_DESCRIPTION =
  "Streamline your deployment process with production-ready templates for popular application stacks. Deploy to any cloud in minutes.";

const HomePage: React.FC = () => {
  return (
    <Box component="main" id="main">
      <DocumentHead
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        path={ROUTES.HOME}
      />
      <JsonLd
        data={{
          "@type": "Organization",
          name: "Rusha",
          url: "https://rusha.io",
          logo: "https://rusha.io/favicon.svg",
          description: HOME_DESCRIPTION,
        }}
      />
      <JsonLd
        data={{
          "@type": "WebSite",
          name: "Rusha",
          url: "https://rusha.io",
        }}
      />
      <JsonLd
        data={{
          "@type": "SoftwareApplication",
          name: "Rusha",
          applicationCategory: "DeveloperApplication",
          operatingSystem: "Web",
          description: HOME_DESCRIPTION,
          url: "https://rusha.io",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
          },
        }}
      />
      <Hero />
      <Features />
      <HowItWorks />
      <TemplateShowcase />
      <VSCodeExtension />
      <CTA />
    </Box>
  );
};

export default HomePage;
